import {Modal} from 'bootstrap';
const initCF7SubmitModal = () => {
    const modalElement = document.querySelector('.formFeedbackModal');
   if(!modalElement) return;
    const formFeedbackModal = new Modal(modalElement, {});
    document.addEventListener( 'wpcf7submit', function( event ) {
        const { status, message } = event.detail.apiResponse;
        const feedbackContent = document.querySelector('#formFeedbackContent');
        console.log(status === 'validation_failed' ? "Oops" : "Success", message);
        feedbackContent.innerHTML = `<div class="${status === 'validation_failed' ? 'text-danger' : 'text-success'}">${message}</div>`;
        formFeedbackModal.show();
    }, false );

  };

export default initCF7SubmitModal;
